module.exports = __webpack_public_path__ + "img/hr-car-3.7c1a7dc6.png";